import { useState } from "react"
import { FiX } from "react-icons/fi"
import Modal from "../../../shared/modal/Modal"
import Button from "../../../shared/components/Button/Button"
import SelectSellersList from "./SelectSellersList"
import "./SelectSellers.css"

function SelectSellers({ data, dataArray, btCancelAction, handleOnSave, readOnly }) {

    const [modalSellers, setModalSellers] = useState(false)
    const [sellers, setSellers] = useState(dataArray || [])

    const removeItem = (item) => {
        setSellers(sellers.filter((s) => s._id !== item._id))
    }

    const handleOnSelectItemSeller = (data) => {
        setSellers(data)
    }

    return (
        <section className="ss-page">

            <div className="ss-header">
                <div className="ss-header-title">
                    <p className="ss-title">{data.name}</p>
                    <span className="ss-title-accent" />
                </div>
                <div className="ss-header-actions">
                    {!readOnly && <Button variant="save" onClick={() => handleOnSave(sellers)}>Salvar</Button>}
                    {!readOnly && <Button variant="select" onClick={() => setModalSellers(true)}>Selecionar</Button>}
                    <Button variant="cancel" onClick={() => btCancelAction()}>{readOnly ? 'Fechar' : 'Cancelar'}</Button>
                </div>
            </div>

            <p className="ss-subtitle">Vendedores associados</p>

            <div className="ss-list">
                {sellers && sellers.length > 0 ? (
                    sellers.map((item) => (
                        <div key={item._id} className="ss-item">
                            <span className="ss-item-name">{item.name}</span>
                            {!readOnly && (
                                <button type="button" className="ss-item-remove" title="Remover" onClick={() => removeItem(item)}>
                                    <FiX size={18} />
                                </button>
                            )}
                        </div>
                    ))
                ) : (
                    <p className="ss-empty">Nenhum vendedor associado</p>
                )}
            </div>

            <Modal
                modalStatus={modalSellers}
                changeStatus={setModalSellers}
                w={60}
                content={
                    <SelectSellersList
                        handleOnSelectItem={handleOnSelectItemSeller}
                        selectedData={sellers}
                        onFinishSelect={() => setModalSellers(false)}
                    />
                }
            />

        </section>
    )
}

export default SelectSellers
